
<template>
  <b-container id="customers-container" fluid class="no-sided-margin">
    <b-row>
      <b-col class="no-sided-padding">
        <b-tabs ref="customers-tabs" v-model="tab" fill pills card>
          <b-tab title="Ricerca">
            <div>
              <b-alert :show="showAlert" dismissible @dismissed="showAlert = false">
                Visualizza le anagrafiche degli utenti dell'app TuDay (Autonomous Store) e lo storico delle modifiche apportate.
              </b-alert>
            </div>
            <Users :session="session"/>
          </b-tab>
          <b-tab title="Mostra dettaglio">
            <div>
              <b-alert :show="showAlert" dismissible @dismissed="showAlert = false">
                Visualizza le anagrafiche degli utenti dell'app TuDay (Autonomous Store) e lo storico delle modifiche apportate.
              </b-alert>
            </div>
            <DetailAnagraphic :session="session"/>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
    <div style="float: right">
      <p style="font-size: 11px">Powered by <img width="100px" src="../assets/CherryChainLogo.png" alt="CherryChain"></img></p>
    </div>
  </b-container>
</template>

<script>
import Users from "@/components/senseiAnagraphics/Users.vue";
import DetailAnagraphic from "@/components/senseiAnagraphics/UserDetail.vue";
import eventBus from "@/EventBus";

export default {
  name: 'Sensei',
  props: ['session'],
  components: {DetailAnagraphic, Users},
  data: () => ({
    showAlert: false,
    SENSEI_ANAGRAPHIC: 0,
    SENSEI_DETAIL: 1,
    tab: 0,
  }),
  mounted() {
    eventBus.$on("show-alert", () => this.showAlert = true)
    eventBus.$on('show-userDetails', (charges) => {
      const tab = this.isEmpty(charges) ? this.SENSEI_ANAGRAPHIC : this.SENSEI_DETAIL;
      this.switchTab(tab)
    })
  },
  methods: {
    isEmpty(object) { return Object.keys(object).length === 0 },
    switchTab(tab) { this.tab = tab }
  }
}
</script>


<style scoped>
</style>
